module.exports = __webpack_public_path__ + "img/food_savior_canvas.b2205974.png";